export default "__VITE_ASSET__DqVEfWm8__"